import React, { Component } from "react";

import NavigationView from "features/new/navigation/view";

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = { shouldNavigationBarVisible: false };
  }

  componentDidMount() {
    this.animateSlideIn();

    window.addEventListener("resize", () => this.animateSlideIn());
    window.addEventListener("scroll", () => this.animateSlideIn());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.animateSlideIn());
    window.removeEventListener("scroll", () => this.animateSlideIn());
  }

  animateSlideIn() {
    let header = document.getElementsByClassName("header")[0];

    if (header) {
      header.getBoundingClientRect().top + header.offsetHeight / 2 <= 0
        ? this.setState({ shouldNavigationBarVisible: true })
        : this.setState({ shouldNavigationBarVisible: false });
    }
  }

  render() {
    const { shouldNavigationBarVisible } = this.state;

    return (
      <NavigationView shouldNavigationBarVisible={shouldNavigationBarVisible} />
    );
  }
}

export default Navigation;
